import {useQuery} from "@tanstack/react-query";
import {useParams} from "react-router-dom";
import {getEventData} from "./getEvent";
import axios from "../../axios";

export function useGetEvent() {
  const {eventId} = useParams<{eventId: string}>();

  return useQuery({
    queryKey: ["event", eventId],
    queryFn: async () => {
      if (!eventId) throw new Error("Event id is required");
      const response = await getEventData(
        {data: {eventId: parseInt(eventId)}},
        axios
      );
      return response;
    },
    enabled: !!eventId,
    retry: false,
    throwOnError: true,
  });
}
